import { Link, useNavigate } from "react-router-dom";
import {
  Panel,
  PanelHeader,
  PanelBody,
} from "../../../../components/panel/panel";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import * as formik from "formik";
import Swal from "sweetalert2";
import { updateCustomerSocialReason } from "../../../../services/CatalogService";
import { getOneCustomerSocialReason } from "../../../../services/CatalogService";
import CustomerSocialReasonFields from "./formCustomerSocialReason/customerSocialReasonFields";
import {
  customerSocialReasonValidationSchema,
  customerSocialReasonInitialValues,
} from "./formCustomerSocialReason/customerSRFormConfig";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Loader from "../../../../components/loader/index";

function VaroExpressEditCustomerSocialR() {
  const razonSocial = 'VaroExpress';

  const { id } = useParams(); // obtiene el ID desde la URL
  const [initialValues, setInitialValues] = useState(
    customerSocialReasonInitialValues
  );
  const [isLoading, setIsLoading] = useState(true);
  
  const navigate = useNavigate();
  const { Formik } = formik;

  function AutoValidateOnMount({ setTouched, validateForm }) {
      useEffect(() => {
        const allFieldsTouched = Object.keys(customerSocialReasonInitialValues).reduce(
          (acc, key) => ({ ...acc, [key]: true }),
          {}
        );
        setTouched(allFieldsTouched, true);
        validateForm();
      }, [setTouched, validateForm]);
  
      return null;
    }

  useEffect(() => {
    async function fetchData() {
      try {
        const data = await getOneCustomerSocialReason(id, razonSocial);
        setInitialValues({
          ...customerSocialReasonInitialValues,
          ...data,
          idCustomerSocialReason: data.id,
          fiscalRegimeId: data.fiscalRegime || null,
          cfdiId: data.cfdi || null,
        });
      } catch (error) {
        console.error("Error al cargar datos:", error);
      } finally {
        setIsLoading(false);
      }
    }

    if (id) {
      fetchData();
    }
  }, [id]);

   if (isLoading) {
    return <Loader />;
  }

  return (
    <div>
      <div className="d-flex align-items-center mb-3">
        <div>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/">Inicio</Link>
            </li>
            <li className="breadcrumb-item">Configuración</li>
            <li className="breadcrumb-item">
              <Link to="/billing-VaroExpress/CustomerSocialReason">
                Clientes razón social - Varo Express
              </Link>
            </li>
            <li className="breadcrumb-item active">Editar Cliente</li>
          </ol>
          <h1 className="page-header mb-0">Editar cliente</h1>
        </div>
      </div>

      <div className="row mb-3">
        <div className="col-xl-12">
          <Panel>
            <PanelHeader>Edición de cliente</PanelHeader>
            <PanelBody>
              <Formik
                enableReinitialize={true}
                validationSchema={customerSocialReasonValidationSchema}
                initialValues={initialValues}
                onSubmit={async (values, { setSubmitting }) => {
                  try {
                    const payload = {
                      ...values,
                      fiscalRegimeId: values.fiscalRegimeId?.id?.toString() || null,
                      cfdiId: values.cfdiId?.id?.toString() || null,
                      name: values.name ? values.name.trimEnd() : values.name,
                    };
                    delete payload.id;
                    delete payload.fiscalRegime;
                    delete payload.cfdi;
                    const idToUpdate = payload.idCustomerSocialReason;
                    delete payload.idCustomerSocialReason;
                    delete payload.createdAt;
                    delete payload.updateAt;


                    //console.log(payload);
                    //console.log("ID para actualizar:", payload.idCustomerSocialReason);
                    await updateCustomerSocialReason(idToUpdate, razonSocial, payload);

                    Swal.fire({
                      title: "Edición exitosa",
                      text: "Se ha editado el cliente",
                      icon: "success",
                      confirmButtonText: "Cerrar",
                    });

                    navigate("/billing-VaroExpress/CustomerSocialReason");
                  } catch (err) {
                    Swal.fire({
                      title: "Ups!",
                      text: err.response?.data?.message || "Error al registrar",
                      icon: "error",
                      confirmButtonText: "Cerrar",
                    });
                  } finally {
                    setSubmitting(false);
                  }
                }}
              >
                {({
                  handleSubmit,
                  handleChange,
                  handleBlur,
                  values,
                  touched,
                  errors,
                  setTouched,      
                  validateForm 
                }) => (
                  <Form noValidate onSubmit={handleSubmit}>
                    <AutoValidateOnMount
                      setTouched={setTouched}
                      validateForm={validateForm}
                    />   
                    <CustomerSocialReasonFields
                      values={values}
                      errors={errors}
                      touched={touched}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      setFieldValue={(field, value) => {
                        if (["fiscalRegimeId", "cfdiId"].includes(field)) {
                          if (!value || Object.keys(value).length === 0) {
                            values[field] = null;
                          } else {
                            values[field] = value;
                          }
                        } else {
                          values[field] = value;
                        }
                      }}
                    />

                    <Row className="mb-3">
                      <Col md="12" className="text-end">
                        <Button type="submit">Guardar Cliente</Button>{" "}
                        <Link
                          to="/billing-VaroExpress/CustomerSocialReason"
                          className="btn btn-info"
                        >
                          Cancelar
                        </Link>
                      </Col>
                    </Row>
                  </Form>
                )}
              </Formik>
            </PanelBody>
          </Panel>
        </div>
      </div>
    </div>
  );
}

export default VaroExpressEditCustomerSocialR;
